import { useCallback } from 'react';
import { TableConfigDto } from '@asset-metrix/portal-gateway-client-js';

import { useDocumentSigning } from './useDocumentSigning';
import { useWorkflowActionModalProperties } from './useWorkflowActionModalProperties';
import { WorkflowActionModalProps } from './WorkflowActionModal';

type UseWorkflowModalReturnValue = {
  workflowActionModalProps?: WorkflowActionModalProps;
  open: (
    modalId: string,
    rowIds: string[],
    action: string,
    data: Record<string, unknown>[],
    documentId?: string
  ) => void;
};

export function useWorkflowModal(
  pageId: string,
  contentId: string,
  config: TableConfigDto
): UseWorkflowModalReturnValue {
  const { open: openWorkflowActionModal, workflowActionModalProps } =
    useWorkflowActionModalProperties(pageId, contentId, config);
  const { open: openDocumentSigning } = useDocumentSigning(
    pageId,
    contentId,
    config
  );

  const open = useCallback(
    (
      modalId: string,
      rowIds: string[],
      action: string,
      data: Record<string, unknown>[],
      documentId?: string
    ) => {
      const modal = config.workflowModalSchemas?.[modalId];
      if (modal == null) {
        return;
      }

      switch (modal.modalType) {
        case 'workflowAction':
          openWorkflowActionModal(modalId, rowIds, action, data);
          break;
        case 'documentSign':
          if (documentId == null) {
            throw new Error(
              `DocumentId missing for documentSign modal with id ${modalId}`
            );
          }
          openDocumentSigning(modalId, rowIds[0], action, documentId);
      }
    },
    [config.workflowModalSchemas, openDocumentSigning, openWorkflowActionModal]
  );

  return { open, workflowActionModalProps };
}
